import { render } from "./IframeCovid.page.vue?vue&type=template&id=5b0ff853"
import script from "./IframeCovid.page.vue?vue&type=script&lang=js"
export * from "./IframeCovid.page.vue?vue&type=script&lang=js"

import exportComponent from "/builds/ASIP-Sante/g1/shared/santefr/web/modules/custom/sante_vuejs/vue-core/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/iframe/IframeCovid.page.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5b0ff853"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5b0ff853', __exports__)) {
    console.log('reload')
    api.reload('5b0ff853', __exports__)
  }
  
  module.hot.accept("./IframeCovid.page.vue?vue&type=template&id=5b0ff853", () => {
    console.log('re-render')
    api.rerender('5b0ff853', render)
  })

}


export default __exports__